import styled from '@emotion/styled';
import React from 'react';

import { pxToRem } from 'src/shared/helpers/pxToRem';

import { ComponentTextMedium } from '../Typography';
import { dsColors } from '../variables';

const Wrapper = styled.li<{ selected: boolean }>(({ selected }) => ({
    paddingTop: pxToRem(20),
    paddingBottom: pxToRem(20),
    marginBottom: pxToRem(10),
    width: '100%',
    border: `${pxToRem(2)} solid ${selected ? dsColors.blue : dsColors.lightGrey}`,
    borderRadius: pxToRem(5),
    cursor: 'pointer',
    userSelect: 'none',
}));

interface Props {
    text: string;
    active: boolean;
    onClick: () => void;
}

export const AnswerButtonForMultiSelect: React.FC<Props> = ({ active, text, onClick }) => (
    <Wrapper selected={active} onClick={onClick}>
        <ComponentTextMedium centered>{text}</ComponentTextMedium>
    </Wrapper>
);
